<template>
  <div>
    <table-card title='Accounts' :items='accounts' :fields='accountFields'>
      <template v-slot:cell(permissions)="data">
        {{ data.unformatted | prettyList }}
      </template>
      <template v-slot:cell(actions)="data">
        <span v-if="canEditUsers">
          <b-btn :to="{ name: toRoute, params: { cid: companyId, uid: data.item.id } }" size="sm"
                 variant="secondary">Edit</b-btn>
        </span>
      </template>
    </table-card>

    <div v-if="canEditUsers" class="row text-left">
      <div class="col-sm">
        <b-btn type="button" variant="primary" class="my-3 mx-0" :to="{ name: 'AccountCreate', params: { cid: companyId, uid: 'new' }}">
          New User
        </b-btn>
      </div>
    </div>

  </div>
</template>

<script>
    import TableCard from '@/components/TableCard'
    import {AccountsApi} from '@/accounts/api'
    import auth from '@/auth'

    export default {
        props: {
            cid: {required: false, type: String},
            toRoute: { required: true, type: String }
        },
        data() {
            return {
                accounts: [],
                accountFields: [
                    {key: 'id'},
                    {key: 'name'},
                    {key: 'email'},
                    {key: 'permissions'},
                    {key: 'actions', label: ''}
                ]
            }
        },
        created() {
            this.listUsers()
        },
        methods: {
            listUsers() {
                AccountsApi.listAccounts(this.cid).then(data => {
                    this.accounts = data.accounts
                })
            }
        },
        computed: {
            canEditUsers() {
                return auth.isAdmin()
            },
            companyId() {
                return this.cid ? this.cid : auth.details().company_id
            }
        },
        filters: {
            prettyList(list) {
                return list.map((str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()).join(', ')
            },
        },
        components: {
            TableCard
        }
    }
</script>



// WEBPACK FOOTER //
// src/accounts/pages/AccountList.vue